<template>
	<section id="create-list" style="margin-top:100px">
		<container title="Curadores e Produção" textButton="Voltar" pathName="/objetos">
			<section id="params-container">
				<div class="col1-section">
					<div class="table-wrapper">
						<div class="table" style="background-color: #f3f7fc;">
							<table >
								<tbody>
									<td><h3>Período de Produção</h3></td>
									<td style="text-align: end;"><a class="acao" v-on:click="isModalVisible2 = !isModalVisible2">Adicionar &#10010;</a></td>
								</tbody>
							</table>
						</div>
					</div>
					<div class="table-wrapper" >
						<div class="table" >
							<table>
								<thead>
									<tr>
										<th>Período de Produção</th>
										<th style="text-align: end;">Ações</th>
									</tr>
								</thead>

								<tbody>
									<tr class="fields" v-for="item in pedProducoes" v-bind:key="item.id">
										<td><span style="text-transform: none; ">{{item.periodoName}}</span></td>
										<td>
										<div class="btn-container" style="display: flex;  float: right;">
											<span v-on:click="isModalVisible3 = !isModalVisible3">
												<!-- <item-edit class="edit editar acao"></item-edit> -->
											</span>
											<button-remove   :onClick="() => deletePedProducoes(item.id)" class="delete"></button-remove>
										</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					</div>
				<div class="col2-section">
					<div class="table-wrapper">
						<div class="table" style="background-color: #f3f7fc;">
							<table >
								<tbody>
									<td><h3>Curador</h3></td>
									<td style="text-align: end;"><a class="acao" v-on:click="isModalVisible = !isModalVisible">Adicionar &#10010;</a></td>
								</tbody>
							</table>
						</div>
					</div>
					<div class="table-wrapper">
						<div class="table">
							<table  >
								<thead>
									<tr>
										<th>Curador - Email </th>
										<th style="text-align: end;">Ações</th>
									</tr>
								</thead>

								<tbody>
									<tr class="fields" v-for="itemm in nomesCuradores" v-bind:key="itemm.id">
										<td><span style="text-transform: none;">{{itemm.nome}} &lt;{{itemm.email}}></span></td>
										<td>
										<div class="btn-container" style="display: flex; float: right;">
											<!-- <item-edit class="edit editar acao"></item-edit> -->
											<button-remove  :onClick="() => deletecuradoresNomes(itemm.id)" class="delete"></button-remove>
										</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>

				<Modal v-show="isModalVisible" @close="() => this.isModalVisible = !this.isModalVisible">
					<template v-slot:body>
							<div >
								<h3 style="color:#1b3772; padding-bottom: 12px; font-weight:500;">Adicione dados do curador</h3>
								<input type="text" id="cnome" name="cnome"  v-model="formCuradores.nome" placeholder="Nome do curador" >
								<input type="text" id="cmail" name="cmail" v-model="formCuradores.email" placeholder="nome.sobrenome@ensineme.com.br" >
								<button class="send" v-on:click="submitCuradores()">Cadastrar Curador</button>
							</div>
					</template>
						<button-action type="button" :onClick="closeModal" class="xs default">Cancelar</button-action>
					<template v-slot:footer style>
					</template>
				</Modal>

				<Modal v-show="isModalVisible3" @close="() => this.isModalVisible3 = !this.isModalVisible3">
					<template v-slot:body>
							<div v-for="item in pedProducoes" v-bind:key="item.id">
								<h3 style="color:#1b3772; padding-bottom: 12px; font-weight:500;">Atualizar o Período de Produção</h3>
								<input type="text" id="periodoName" name="periodoName" v-model="item.periodoName" >
								<button class="send" :onClick="() => putproducoesPeriodo(item.id)" >Atualizar</button>
							</div>
					</template>
						<button-action type="button" :onClick="closeModal" class="xs default">Cancelar</button-action>
					<template v-slot:footer style>
					</template>
				</Modal>

				<Modal v-show="isModalVisible2" @close="() => this.isModalVisible2 = !this.isModalVisible2">
					<template v-slot:body>
							<div >
								<h3 style="color:#1b3772; padding-bottom: 12px; font-weight:500;">Período de produção</h3>
								<input type="text" id="cpedproducao" name="cpedproducao"  v-model="formPedProducao.periodoName" placeholder="Ex.: Pós Estácio Eng. Software" >
								<button class="send" v-on:click="submitPedProducoes()">Cadastrar</button>
							</div>
					</template>
						<button-action type="button" :onClick="closeModal" class="xs default">Cancelar</button-action>
					<template v-slot:footer>
					</template>
				</Modal>
			</section>
		</container>
	</section>

</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ButtonRemove from '@/components/shared/ButtonRemove'
// import ItemEdit from '@/components/shared/ItemEdit'
import Modal from '@/components/shared/Modal'
import Container from '@/components/shared/Container'
Vue.use(VueAxios, axios)

export default {
	name: 'listData',
	components: {
		Container,
		ButtonRemove,
		Modal
		// ItemEdit,
	},
	data () {
		return {
			isDisabled: false,
			loading: true,
			nomesCuradores: [],
			formCuradores: {
				nome: '',
				email: ''
			},
			pedProducoes: [],
			formPedProducao: {
				id: '',
				periodoName: ''
			},
			another_field: '',
			isModalVisible: false,
			isModalVisible2: false,
			isModalVisible3: false
		}
	},
	created () {
		this.curadoresNomes()
		this.producoesPeriodo()
	},
	computed: {
	},
	methods: {
		async curadoresNomes () {
			await this.axios.get('/curadoresNomes')
				.then(res => {
					this.nomesCuradores = res.data
				})
				.catch(error => {
					console.log(error.response.data.error)
				})
				.finally(() => {
					const err = this.loading = false
					return err
				})
		},
		async deletecuradoresNomes (id) {
			await this.axios.delete(`/curadoresNomes/${id}`)
				.then((res) => {
					this.nomesCuradores = this.nomesCuradores.filter(data => data.id !== id)
				})
				.catch(err => console.log(err))
				.finally(() => {
					const err = this.loading = false
					return err
				})
		},
		async submitCuradores () {
			await this.axios.post('/curadoresNomes', this.formCuradores).then(res => { window.location.reload() })
				.catch(error => {
					console.log(error.res.data.error)
				})
				.finally(() => {
					const err = this.loading = false
					return err
				})
		},
		async producoesPeriodo () {
			await axios.get('/periodoProducao')
				.then(res => {
					this.pedProducoes = res.data
				})
				.catch(error => {
					console.log(error.response.data.error)
				})
				.finally(() => {
					const err = this.loading = false
					return err
				})
		},
		async producoesPeriodoID (id) {
			await axios.get(`/periodoProducao/${id}`)
				.then((res) => {
					this.pedProducoes = this.pedProducoes.filter(data => data.id !== id)
				})
				.catch(error => {
					console.log(error.response.data.error)
				})
				.finally(() => {
					const err = this.loading = false
					return err
				})
		},
		async deletePedProducoes (id) {
			await this.axios.delete(`/periodoProducao/${id}`)
				.then((res) => {
					this.pedProducoes = this.pedProducoes.filter(data => data.id !== id)
				})
				.catch(err => console.log(err))
				.finally(() => {
					const err = this.loading = false
					return err
				})
		},
		async submitPedProducoes () {
			await this.axios.post('/periodoProducao', this.formPedProducao).then(res => { window.location.reload() })
				.catch(error => {
					console.log(error.res.data.error)
				})
				.finally(() => {
					const err = this.loading = false
					return err
				})
		},
		getIndex (newId) {
			this.another_field = this.pedProducoes.findIndex(p => p.id === newId)
		},
		async putproducoesPeriodo (id) {
			// this.pedProducao = this.pedProducoes.filter(data => data.id !== id)
			await this.axios.put(`/periodoProducao/${id}`, { id: this.pedProducao.id, periodoName: this.pedProducao.periodoName })
				.then(res => {
					this.pedProducoes = this.pedProducoes.filter(data => data.id !== id)
					this.isModalVisible3 = false
					// window.location.reload()
				})
				.bind(this)
				.catch(error => {
					console.log(error.res.data.error)
				})
				.finally(() => {
					const err = this.loading = false
					return err
				})
		},
		closeModal () {
			this.isModalVisible = false
		},
		closeModal2 () {
			this.isModalVisible2 = false
		},
		closeModal3 () {
			this.isModalVisible3 = false
		}
	},
	async mounted () {
		// await this.producoesPeriodo()
		// await this.curadoresNomes()
	}
}
</script>

<style>
	.fields input {
		background-color: #ffffff;
		height: 45px;
		margin-left: 0px;
		margin-top: 0px;
		padding: 16px 16px 16px 10px;
	}
	.acao{
		border-radius: 5px;
		text-decoration: none;
		background-color: #3367d6;
		color: #fff;
		padding: 9px 13px;
		font-size: 0.9em;
	}
	.acao:hover{
		background-color: #1A2738;
    color: #f9fdff;
	}
	.main-content .table-wrapper .table table tbody tr td:last-of-type {
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
	}
	.main-content .table-wrapper .table table tbody tr td {
    border-start-start-radius: 0px !important;
    border-end-start-radius: 0px !important;
	}
	.modal-backdrop .modal .modal-footer button[data-v-2fa642f3]{
			background-color: #DC6363 !important;
			width: 100%;
			text-transform: uppercase;
	}
	.modal-footer{
		padding: 0px 10px 20px 10px !important;
	}

	.modal-body{
    padding: 28px 10px 12px !important;
	}

</style>

<style lang="scss" scoped>
#create-list {
	background-color: white;
	padding: 0px 20px;

	#params-container {
		border-radius: 4px;
		margin-top: 15px;
		height: 100%;
		width: 100%;
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		grid-template-areas: "header header " "col1 col2";
		align-items: center;
		gap: 10px;

		#grid-header{
			position: relative;
			grid-area: header;
			top: 5px;
			font-family: $font-family;
			font-size: $font-size;
			font-weight: $font-weight-labels;
			color: #FFF;
		}
		.col1-section{
			grid-area: col1;
			background-color: #ffffff;
			height: 100%;
			margin-left: 0px;
			margin-top: 0px;
		}

		.col2-section{
			grid-area: col2;
			background-color: #ffffff;
			height: 100%;
			margin-left: 0px;
			margin-top: 0px;

		}
		input {
			background-color: #f3f7fc;
			border-radius: 5px;
			color: #4f5c6b;
			min-height: 50px;
		}
		input[type="text"]{
			width: 100%;
			font-size: 0.8em;
			margin-bottom: 10px;
		}
		.send{
			border: none;
			outline: none;
			background-color: #3367D6;
			color: #fff;
			font-family: "Roboto", sans-serif;
			font-weight: 300;
			font-size: 0.79em;
			border-radius: 5px;
			padding: 12px;
			margin-top: 5px;
			width: 100%;
			text-transform: uppercase;
			cursor: pointer;
		}

		.vs__fade-enter-active,
		.vs__fade-leave-active {
			transition: none;
		}

		.v-select.area_3{
			height: 45px;
		}

		#objeto{
			grid-area: tipoObjeto;
			width: 100%;
		}

		#curador{
			grid-area: curador;
			width: 100%;
		}

		#curadoria{
			grid-area: curadoria;
			width: 100%;
		}

		#subcuradoria{
			grid-area: subcuradoria;
		}

		#eixo{
			grid-area: eixo;
			height: 45px;
		}
	}
}
</style>
